/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Emailtemplate_Attachteaser3Inputs */

const en_coinvestments_emailtemplate_attachteaser3 = /** @type {(inputs: Coinvestments_Emailtemplate_Attachteaser3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach teaser`)
};

/**
* | output |
* | --- |
* | "Attach teaser" |
*
* @param {Coinvestments_Emailtemplate_Attachteaser3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_emailtemplate_attachteaser3 = /** @type {((inputs?: Coinvestments_Emailtemplate_Attachteaser3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Emailtemplate_Attachteaser3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_emailtemplate_attachteaser3(inputs)
});
export { coinvestments_emailtemplate_attachteaser3 as "coInvestments_emailTemplate_attachTeaser" }